const USER_STATUS = `/students/status`;
const USER_EXAMS = `/students/exams`;
const USER_BY_ID = `/students/`;
const USER_BY_ID_DOCUMENT = `/user/`;
const ADMISSION = `/students/admission`;
const APPLICATIONS = `/students/applications`;
const PROFILE = `/students/profile`;
const PAY_OFFLINE = `/students/payments/offline`;
const GET_PAYMENT_LINK = `/students/payments/online`;
const APPEAL = `/students/appeals`;
const QR = `/qr`;
const CUSTOM_API = `/students/`;
const GROUPS = `/students/allGroups`;
const SCHEDULE = `/students/schedule/`;
const LESSONS_WEEK = `/students/lessonWeek`;
const COMMANDS = `/students/commands`;
const SURVEYS = `/students/surveys`;
const CONSULTATION = `/students/consultation/`;
const CHECK_DIPLOMA_WORK = '/students/checkDiplomaWorksAllowed';
const UPLOAD_DIPLOMA_WORK = '/students/uploadDiplomaWorks';

const API = {
	USER_STATUS,
	USER_EXAMS,
	USER_BY_ID,
	USER_BY_ID_DOCUMENT,
	ADMISSION,
	APPLICATIONS,
	PAY_OFFLINE,
	GET_PAYMENT_LINK,
	APPEAL,
	PROFILE,
	QR,
	CUSTOM_API,
	GROUPS,
	SCHEDULE,
	LESSONS_WEEK,
	COMMANDS,
	SURVEYS,
	CONSULTATION,
	CHECK_DIPLOMA_WORK,
	UPLOAD_DIPLOMA_WORK
};

export default API;
